export const RELEASE_NOTES = [
    { id: "wishes", date: "2026-10-17" },
];
/** The notes released after the day the reader last said they had read, newest
 *  first. Compared as days: `seenAt` is a timestamp, a note is a date. */
export function unseenReleaseNotes(seenAt, notes = RELEASE_NOTES) {
    const seenDay = seenAt.slice(0, 10);
    return notes.filter((note) => note.date > seenDay);
}
//# sourceMappingURL=release-notes.js.map